import { render, staticRenderFns } from "./HealthDashboardHeader.vue?vue&type=template&id=6b8ad082&"
import script from "./HealthDashboardHeader.vue?vue&type=script&lang=ts&"
export * from "./HealthDashboardHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports